export default class ChessModeWindow {
  constructor({ model, socket, controller }) {
    this.model = model;
    this.socket = socket;
    this.controller = controller;

    // DOM Container for the Chess Mode UI
    this.container = document.createElement("div");
    this.container.id = "chess-mode-window";
    this.container.style.display = "none"; // Hidden by default
    this.container.style.position = "fixed";
    this.container.style.bottom = "10px";
    this.container.style.left = "10px";
    this.container.style.background = "#f0f0f0";
    this.container.style.padding = "10px";
    this.container.style.border = "1px solid #ccc";
    this.container.style.zIndex = "1000";

    // Video Container
    this.videoContainer = document.createElement("div");
    this.videoContainer.id = "chess-video-container";
    this.videoContainer.style.display = "flex";
    this.videoContainer.style.flexWrap = "wrap";
    this.videoContainer.style.gap = "10px";

    // Buttons Container
    this.buttonsContainer = document.createElement("div");
    this.buttonsContainer.id = "chess-buttons-container";
    this.buttonsContainer.style.marginTop = "10px";

    // Join Button
    this.joinButton = document.createElement("button");
    this.joinButton.textContent = "Join Game";
    this.joinButton.addEventListener("click", () => this.handleJoin());

    // Leave Button
    this.leaveButton = document.createElement("button");
    this.leaveButton.textContent = "Leave Game";
    this.leaveButton.style.display = "none"; // Hidden until joined
    this.leaveButton.addEventListener("click", () => this.handleLeave());

    // Lock Button
    this.lockButton = document.createElement("button");
    this.lockButton.textContent = "Lock Game";
    this.lockButton.style.display = "none"; // Hidden until player
    this.lockButton.addEventListener("click", () => this.handleLock());

    // Unlock Button
    this.unlockButton = document.createElement("button");
    this.unlockButton.textContent = "Unlock Game";
    this.unlockButton.style.display = "none"; // Hidden until locked
    this.unlockButton.addEventListener("click", () => this.handleUnlock());

    // Reset Game Button
    this.resetButton = document.createElement("button");
    this.resetButton.textContent = "Reset Game";
    this.resetButton.style.display = "none"; // Hidden until player
    this.resetButton.addEventListener("click", () => {
      this.model.dispatchEvent({ type: SCENE_INTERACTION.CHESS_RESET_GAME });
    });

    // Take Seat Buttons (White and Black)
    this.takeWhiteSeatButton = document.createElement("button");
    this.takeWhiteSeatButton.textContent = "Take White Seat";
    this.takeWhiteSeatButton.addEventListener("click", () => this.handleTakeSeat("white"));

    this.takeBlackSeatButton = document.createElement("button");
    this.takeBlackSeatButton.textContent = "Take Black Seat";
    this.takeBlackSeatButton.addEventListener("click", () => this.handleTakeSeat("black"));

    this.video = document.createElement("video");
    this.video.id = "myChessVideo";
    this.video.style.display = "flex";
    this.video.style.flexWrap = "wrap";
    this.video.style.gap = "10px";

    // Append elements to containers
    this.buttonsContainer.append(
      this.joinButton,
      this.leaveButton,
      this.lockButton,
      this.unlockButton,
      this.resetButton,
      this.takeWhiteSeatButton,
      this.takeBlackSeatButton,
      this.video
    );
    this.container.append(this.videoContainer, this.buttonsContainer);

    // Append to document body
    document.body.appendChild(this.container);

    // Event listeners for stream management
    // this.model.addEventListener(SCENE_INTERACTION.STREAM_RECIEVED, (e) => this.addVideo(e.data));
    // this.model.addEventListener(SCENE_INTERACTION.STREAM_REMOVED, (e) => this.removeVideo(e.data.streamId));
  }

  // Show the Chess Mode window
  show() {
    this.container.style.display = "block";
  }

  // Hide the Chess Mode window
  hide() {
    this.container.style.display = "none";
    this.resetUI();
  }

  // Show video section
  showVideo() {
    this.videoContainer.style.display = "flex";
  }

  // Handle joining the game as a watcher or player
  handleJoin() {
    // this.model.dispatchEvent({ type: SCENE_EVENTS.CHESS_MODE_START });
    this.joinButton.style.display = "none";
    this.leaveButton.style.display = "block";
    if (this.controller.isPlayer) {
      this.showPlayerControls();
    }
  }

  // Handle leaving the game
  handleLeave() {
    // this.model.dispatchEvent({ type: SCENE_EVENTS.CHESS_MODE_ENDED });
    this.resetUI();
  }

  // Handle locking the game
  handleLock() {
    // this.model.dispatchEvent({ type: SCENE_INTERACTION.CHESS_TOGGLE_LOCK });
    this.lockButton.style.display = "none";
    this.unlockButton.style.display = "block";
  }

  // Handle unlocking the game
  handleUnlock() {
    // this.model.dispatchEvent({ type: SCENE_INTERACTION.CHESS_TOGGLE_LOCK });
    this.unlockButton.style.display = "none";
    this.lockButton.style.display = "block";
  }

  // Handle taking a seat (white or black)
  handleTakeSeat(seatId) {
    this.model.dispatchEvent({
      type: SCENE_INTERACTION.CHESS_TAKE_SEAT,
      data: { seatId }
    });
    this.showPlayerControls();
    this.takeWhiteSeatButton.style.display = "none";
    this.takeBlackSeatButton.style.display = "none";
  }

  // Show controls available to players
  showPlayerControls() {
    this.lockButton.style.display = "block";
    this.resetButton.style.display = "block";
  }

  // Reset UI to initial state
  resetUI() {
    this.joinButton.style.display = "block";
    this.leaveButton.style.display = "none";
    this.lockButton.style.display = "none";
    this.unlockButton.style.display = "none";
    this.resetButton.style.display = "none";
    this.takeWhiteSeatButton.style.display = "block";
    this.takeBlackSeatButton.style.display = "block";
    this.videoContainer.innerHTML = ""; // Clear video container
  }

  // Add a video stream to the container
  addVideo(data) {
    const { streamId, stream } = data;
    const videoWrapper = document.createElement("div");
    videoWrapper.id = `chess-video-wrapper-${streamId}`;
    videoWrapper.style.position = "relative";
    videoWrapper.style.width = "200px"; // Adjust size as needed

    const videoElement = document.createElement("video");
    videoElement.id = `chessRemoteVideo-${streamId}`;
    videoElement.autoplay = true;
    videoElement.playsInline = true;
    videoElement.srcObject = stream;

    // Remove Watcher Button (only for players)
    if (this.controller.isPlayer) {
      const removeButton = document.createElement("button");
      removeButton.textContent = "Remove";
      removeButton.style.position = "absolute";
      removeButton.style.top = "5px";
      removeButton.style.right = "5px";
      removeButton.addEventListener("click", () => {
        this.model.dispatchEvent({
          type: SCENE_INTERACTION.CHESS_REMOVE_WATCHER,
          data: { watcherId: streamId }
        });
      });
      videoWrapper.appendChild(removeButton);
    }

    videoWrapper.appendChild(videoElement);
    this.videoContainer.appendChild(videoWrapper);
  }

  // Remove a video stream from the container
  removeVideo(streamId) {
    const videoWrapper = document.getElementById(`chess-video-wrapper-${streamId}`);
    if (videoWrapper) {
      videoWrapper.remove();
    }
  }
}